import React from 'react';
const CheckIcon = ({
  className = '',
  color = '#FFF6DE',
  width = 14,
  height = 14
}) => {
  return <svg width={width} height={height} className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.25 9.46094L11.4297 3.25391L12.25 4.07422L5.25 11.0742L1.99609 7.82031L2.78906 7L5.25 9.46094Z" fill={color} />
    </svg>;
};
export default CheckIcon;